import { useEffect, useRef } from 'react';

/**
 * Same as use effect but doesnt run on first run.
 * @param func function to run
 * @param deps dependencies
 */
export const useDidUpdateEffect = (func: Function, deps?: React.DependencyList) => {
    const didMount = useRef(false);
    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
